<template>
  <div class="h-100">
    <hero class="h-100 bg"/>
  </div>
</template>

<script>
import Hero from "./components/Hero";
export default {
  name: "home",
  components: {
    Hero
  }
};
</script>

<style scoped>
body,
html {
  height: 100%;
}

.bg {
  /* The image used */
  background-image: url('/img/ff/Web_Home.png');
  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.hide {
  visibility: hidden;
}
</style>
